<template>
    <div>
        <div class="mb-3">
            <BackButton/>
        </div>

        <div class="card card-body">
            <div class="form-group">
                <label>
                    {{ __('general.registration_link') }}
                </label>
                <div class="input-group">
                    <input id="registration_link" type="text" class="form-control" :value="link" readonly>
                    <div class="input-group-append">
                        <button class="btn btn-primary" @click="copyLink">
                            {{ __('actions.copy') }}
                        </button>
                    </div>
                </div>
                <span class="form-text text-muted">
                    {{ __('agency.registration.link.share') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";

export default {
    components: {BackButton},

    props: {
        link: String
    },

    methods: {
        copyLink() {
            navigator.clipboard.writeText(this.link);
            toastr.success(this.__('general.link_copied'));
        }
    }
}
</script>
